// nOffresBox.vue

<template>
  <v-container>
            <v-btn to="/choixcategorieoffre">Retour</v-btn><br><br>
       <v-divider></v-divider>
    <h1>Présentation des offres BOX classées par catégorie (THD, 4G, ADSL)</h1>
    <br />
    <br />
    <div class="text-right">
      <v-btn dark color="red accent-4" large to="/souscription/offresbox/eligibilite/adresse">
        Test d'éligibilité
        <v-icon right dark>mdi-map-marker</v-icon>
      </v-btn>
    </div>
  </v-container>
</template>
<script>
export default {};
</script>